import { apiFetch } from '../utils/api';
import { UserProfile } from './auth';

export interface FetchUsersParams {
  search?: string;
  page?: number;
  limit?: number;
  role?:
    | 'COMPANY_OWNER'
    | 'STORE_MANAGER'
    | 'RETAIL_PLANNER'
    | 'MASTER'
    | 'WAREHOUSE_MANAGER'
    | 'DIRECTOR'
    | 'TECHNICIAN'
    | 'ADVISOR'
    | 'ADMIN';
}

export interface PaginatedUsersResponse {
  data: (UserProfile & { locations?: Array<{ id: number; name: string }> })[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchUsers = (params: FetchUsersParams = {}): Promise<PaginatedUsersResponse> => {
  const searchParams = new URLSearchParams();

  if (params.search) {
    searchParams.set('search', params.search.trim());
  }

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }
  if (params.role) {
    searchParams.set('role', params.role);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedUsersResponse>(`/users${query ? `?${query}` : ''}`);
};
